import React from 'react';

export default function HamburgerIcon({ className = '', title }) {
  return (

 
    <svg
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M13 12C13.5521 12.0002 14 12.4479 14 13C13.9999 13.552 13.552 13.9998 13 14H1C0.4478 14 0.00011 13.5522 0 13C0 12.4477 0.447733 12 1 12H13ZM13 6C13.5521 6.00022 14 6.44786 14 7C13.9999 7.55209 13.552 7.99978 13 8H1C0.447769 8 0.000059 7.55223 0 7C0 6.44772 0.447733 6 1 6H13ZM13 0C13.5521 0.000219791 14 0.447859 14 1C14 1.55213 13.5521 1.99978 13 2H1C0.447738 2 0.000008 1.55227 0 1C0 0.447724 0.447733 0 1 0H13Z" />
    </svg>

  );
}

